import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ErrorState } from '../../components/ErrorState';
import { PageWrapper } from '../../components/PageWrapper';
import { Status as SubscriptionStatus, Tier } from '../../services/subscription/types';
import { EnterpriseSubscriptionDetails } from './EnterpriseSubscriptionDetails';
import { FreeSubscriptionDetails } from './FreeSubscriptionDetails';

export const SubscriptionDetailsPage: React.FC = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { subscriptionDetails } = location.state ?? {};
    const [showError, setShowError] = useState(false);

    const renderSubscriptionComponent = (): React.ReactNode => {
        if (!subscriptionDetails) {
            return <ErrorState />;
        }

        const tier = subscriptionDetails.subscriptionTier;

        switch (tier) {
            case Tier.FREE:
                return (
                    <FreeSubscriptionDetails
                        organizationName={subscriptionDetails.organizationName as string}
                        subscriptionStatus={subscriptionDetails.subscriptionStatus as SubscriptionStatus}
                        subscriptionTier={subscriptionDetails.subscriptionTier as Tier}
                        deviceLimit={subscriptionDetails.deviceLimit as number}
                        currentDeviceCount={subscriptionDetails.currentDeviceCount as number}
                        rateLimit={subscriptionDetails.rateLimit as number}
                        statusGaugeColor={subscriptionDetails.statusGaugeColor as string}
                    />
                );
            case Tier.ENTERPRISE:
                return (
                    <EnterpriseSubscriptionDetails
                        licenseId={subscriptionDetails.licenseId}
                        organizationId={subscriptionDetails.organizationId as string}
                        organizationName={subscriptionDetails.organizationName as string}
                        renewalDate={subscriptionDetails.renewalDate as string}
                        subscriptionStatus={subscriptionDetails.subscriptionStatus as SubscriptionStatus}
                        subscriptionTier={subscriptionDetails.subscriptionTier as Tier}
                        statusGaugeColor={subscriptionDetails.statusGaugeColor as string}
                        setShowError={setShowError}
                    />
                );
            default:
                return <ErrorState />;
        }
    };

    return (
        <PageWrapper title={t('SUBSCRIPTION_DETAILS_PAGE.TITLE')}>
            {showError ? <ErrorState /> : renderSubscriptionComponent()}
        </PageWrapper>
    );
};
